import React from 'react';
import { BookOpenIcon, CalendarCheckIcon, ClipboardCheckIcon, Gamepad2Icon, MessageCircleIcon, PuzzleIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  calendar: CalendarCheckIcon,
  message: MessageCircleIcon,
  puzzle: PuzzleIcon,
  book: BookOpenIcon,
  gamepad: Gamepad2Icon,
  check: ClipboardCheckIcon
};

/* Colores de cada tomo, igual que en la portada del pack */
const TOMO_COLORS = ['bg-brand-red text-white', 'bg-brand-yellow text-brand-ink', 'bg-brand-green text-brand-ink', 'bg-brand-blue text-white', 'bg-brand-violet text-white', 'bg-brand-sky text-brand-ink'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-blue" data-id="element-165" data-mp="ks250z7c8o8n">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-166" data-mp="kq7glawuydzt">
        <p className="text-xs font-semibold uppercase tracking-widest text-brand-yellow" data-id="element-167" data-mp="fv1v2d7db1c9">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-168" data-mp="3b8xbzrn34yjj">
          6 tomos en un solo sistema, creados para organizar la enseñanza del
          inglés inicial.
        </h2>
        <p className="mt-1 font-display text-sm font-bold uppercase leading-tight text-brand-yellow sm:text-base" data-id="element-169" data-mp="3k80vuxu2thz3">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/85" data-id="element-170" data-mp="3u7jf1c25wzq3">
          No es simplemente otra colección de ebooks. Es una ruta de enseñanza
          que organiza contenidos, actividades y herramientas para que sepas
          qué trabajar primero, cómo avanzar y cómo evaluar el aprendizaje.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-171" data-mp="bwep8uf6z98o">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl bg-white text-left text-brand-ink" data-id="element-172" data-mp="2cw1l18tpzlui" data-mpi={i}>
                <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-1 ${TOMO_COLORS[i]}`} data-id="element-173" data-mp="2mo77y4547d2u">
                  <span className="text-xs font-bold uppercase tracking-wider" data-id="element-174" data-mp="2vmrk0mg66oi3">
                    Tomo
                  </span>
                  <span className="font-display text-3xl font-bold leading-none" data-id="element-175" data-mp="2rkxoesku0aos">
                    {i + 1}
                  </span>
                  <Icon size={13} aria-hidden="true" data-id="element-176" data-mp="35j4fnpv9zcfh" />
                </span>
                <div className="p-2.5" data-id="element-177" data-mp="30n6xde0gbw02">
                  <h3 className="sr-only" data-id="element-178" data-mp="1b77hzf68pabz">Tomo {i + 1}</h3>
                  <p className="text-sm font-bold uppercase leading-tight" data-id="element-179" data-mp="1b7por5qj36y5">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-180" data-mp="3hvpyglzw3bcp">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-181" data-mp="386ol73kqb82f">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}